import { Routes } from '@angular/router';
import { ChatComponent } from '@lp/views/chat';
import { MsalGuard } from '@azure/msal-angular';
import { loggedOffGuard } from '@lp/guards/logged-off';
import { modeAvailableGuard } from '@lp/guards/mode-available';
import { rolesAvailableGuard } from '@lp/guards/roles';
import { WelcomeComponent } from '@lp/views/welcome';
import { APP_ROUTES } from '@lp/routes';

export const routes: Routes = [
  {
    path: '',
    component: WelcomeComponent,
    pathMatch: 'full',
    canActivate: [loggedOffGuard()]
  },
  {
    path: '',
    canActivate: [MsalGuard],
    canActivateChild: [rolesAvailableGuard],
    children: [
      {
        path: APP_ROUTES.chat,
        component: ChatComponent,
        loadChildren: () => import('@lp/views/chat').then((m) => m.routes),
        pathMatch: 'full'
      },
      {
        path: `${APP_ROUTES.chat}/${APP_ROUTES.mode}`,
        component: ChatComponent,
        loadChildren: () => import('@lp/views/chat').then((m) => m.routes),
        canActivate: [modeAvailableGuard]
      }
    ]
  },
  {
    path: APP_ROUTES.loader,
    loadComponent: () => import('@lp/views/loader').then((m) => m.LoaderComponent)
  },
  {
    path: APP_ROUTES.error,
    loadComponent: () => import('@lp/views/error').then((m) => m.ErrorComponent)
  },
  {
    path: '**',
    loadComponent: () => import('@lp/views/not-found').then((m) => m.NotFoundComponent)
  }
];
